import React from "react";
import {
    GridRow,
    GridColumn,
    ListTable,
    Grid,
    SearchBox,
    Stack,
    ClearFiltersButton,
    ContentSection,
    ButtonRenderProps,
    ButtonProps
} from "sprint-common-web";

import { CreateWatermarkRuleButton } from "./buttons/create/CreateWatermarkRuleButton";
import { createWatermarkRuleListingColumns } from "./createWatermarkRuleListingColumns";
import { useWatermarkRuleListing } from "./useWatermarkRuleListing";
import { useWatermarkRuleListingFilters } from "./useWatermarkRuleListingFilters";

export const WatermarkRuleListing: React.FC = () => {
    const { filters, setSort, setPage, setPageSize, setAirlineName, clearFilters } = useWatermarkRuleListingFilters();
    const { items, totalItems, isLoading } = useWatermarkRuleListing(filters);

    const columns = createWatermarkRuleListingColumns();

    const createWatermarkRuleButton: ButtonRenderProps<ButtonProps> = {
        render: CreateWatermarkRuleButton
    };

    return (
        <>
            <ContentSection header={"Watermark Rules"} buttons={[createWatermarkRuleButton]}>
                <Grid>
                    <GridRow>
                        <GridColumn sm={3}>
                            <SearchBox placeholder="Airline" onChange={setAirlineName} value={filters.airlineName} />
                        </GridColumn>
                        <GridColumn sm={9}>
                            <Stack horizontalAlign="end">
                                <ClearFiltersButton onClear={clearFilters} isLabeled={true} />
                            </Stack>
                        </GridColumn>
                    </GridRow>
                    <GridRow>
                        <GridColumn sm={12}>
                            <ListTable
                                columns={columns}
                                items={items}
                                pagination={{
                                    page: filters.page,
                                    pageSize: filters.pageSize,
                                    totalItems,
                                    onPageChange: setPage,
                                    onPageSizeChange: setPageSize
                                }}
                                sort={{ by: filters.sortBy, order: filters.sortOrder }}
                                onSortChange={setSort}
                                isLoading={isLoading}
                            />
                        </GridColumn>
                    </GridRow>
                </Grid>
            </ContentSection>
        </>
    );
};
